import { Component, OnInit, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { UploadService } from '@app/shared/services/upload.service';

@Component({
    selector: 'app-preview',
    templateUrl: './preview.component.html',
    styleUrls: ['./preview.component.scss'],
    standalone: false
})
export class PreviewComponent implements OnInit {

  @Input() documentID:any
  @Input() srid:any

  constructor(public activeModal: NgbActiveModal ,private uploadService:UploadService) { }

  ngOnInit() {
    console.log(this.documentID)
    console.log(this.srid)

    this.uploadService.getPresignURL(this.srid,this.documentID).subscribe(data => {
      console.log(data)
      let presignedURL = data['body']['presignedURL']
      window.open(presignedURL, '_blank');
    })

  }

}
